import styled from "@emotion/styled";
import { DESKTOP } from "@/themes/device";

export const DesktopDivider = styled.div`
  display: none;
  ${DESKTOP} {
    display: block;
  }
`;
